"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333bfIcon = createIcon({
  displayName: "_333bfIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path d="m64.948 51.5h100v100h-100z" fill="currentColor" />
      <path d="m65.448 191.5h100v100h-100z" fill="currentColor" />
      <path d="m65.698 331.5h100v100h-100z" fill="currentColor" />
      <path
        d="m406.334 241.663c4.929-76.658 73.935-190.163-58.733-190.163-111.138 0-118.596 96.192-118.596 190.163 0 84.969 4.044 186.586 106.526 190.163 142.872 4.987 76.281-104.974 70.803-190.163z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333bfIcon;
